import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import partnersReducer from './slices/partnersSlice';
import plansReducer from './slices/plansSlice';
import partnerWorkspaceReducer from './slices/partnerWorkspaceSlice';
import superAdminWorkspaceReducer from './slices/superAdminWorkspaceSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    partners: partnersReducer,
    plans: plansReducer,
    partnerWorkspace: partnerWorkspaceReducer,
    superAdminWorkspace: superAdminWorkspaceReducer
  }
});

export default store;
